module.exports = __webpack_public_path__ + "static/media/knock.ecf96669.mp3";